// -----------------------------------------------------------------------------
// PLUGINS/MENU
// -----------------------------------------------------------------------------
import { Plugin, PluginKey } from "prosemirror-state";
// -----------------------------------------------------------------------------
import { InlineMenuView, BlockMenuView } from "../menu/nav";
// -----------------------------------------------------------------------------
const menuKey = new PluginKey("menu");
export function menuPlugin(containers, items, isInline, id, app) {
    return new Plugin({
        key: menuKey,
        state: {
            init() {
                return { module: null };
            },
            apply(tr, model) {
                let message = tr.getMeta(menuKey);
                if (message) {
                    if (message === "close-module") {
                        model.module = null;
                    }
                    else {
                        model.module = message;
                    }
                }
                return model;
            }
        },
        view: function (editor) {
            let view = isInline
                ? new InlineMenuView(editor, menuKey, items, id, app)
                : new BlockMenuView(editor, menuKey, items, id, app, containers);
            containers.inner.prepend(view.dom);
            view.update();
            return view;
        }
    });
}
